import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {ConfigurationService} from '../../core/services/configuration.service';
import {LoggingService} from "mclane-apptemplate-lib";

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})

export class LogoutComponent {

  constructor(public configurationService: ConfigurationService, private router: Router, public console: LoggingService) {

  }

  ngOnInit() {
    this.console.log('logout=' + this.configurationService.isLogoutCalled);
    if (this.configurationService.isLogoutCalled) {
      this.configurationService.isLogoutCalled = false;
      //this.Auth.logout('');
    } else {
      this.router.navigate([''])
    }
  }
}
